export default __webpack_public_path__ + "static/media/logout-circled.534e1841.svg";